// All of the requested modules are loaded behind enumerable getters.
const map = Object.defineProperties({}, {
  "./(tabs)/(map)/[buildingCode].tsx": { enumerable: true, get() { return require("/Users/benjaminliu/Developer/ConUMap/app/(tabs)/(map)/[buildingCode].tsx"); } },
  "./(tabs)/(map)/_layout.tsx": { enumerable: true, get() { return require("/Users/benjaminliu/Developer/ConUMap/app/(tabs)/(map)/_layout.tsx"); } },
  "./(tabs)/(map)/index.tsx": { enumerable: true, get() { return require("/Users/benjaminliu/Developer/ConUMap/app/(tabs)/(map)/index.tsx"); } },
  "./(tabs)/_layout.tsx": { enumerable: true, get() { return require("/Users/benjaminliu/Developer/ConUMap/app/(tabs)/_layout.tsx"); } },
  "./(tabs)/calendar.tsx": { enumerable: true, get() { return require("/Users/benjaminliu/Developer/ConUMap/app/(tabs)/calendar.tsx"); } },
  "./_layout.tsx": { enumerable: true, get() { return require("/Users/benjaminliu/Developer/ConUMap/app/_layout.tsx"); } },
});

function metroContext(request) {
    return map[request];
}

// Return the keys that can be resolved.
metroContext.keys = function metroContextKeys() {
  return Object.keys(map);
};

// Return the module identifier for a user request.
metroContext.resolve = function metroContextResolve(request) {
  throw new Error('Unimplemented Metro module context functionality');
}

module.exports = metroContext;